import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "mb-6 text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl flex items-center gap-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Recently Funded", -1)
const _hoisted_4 = { class: "grid w-full grid-cols-1 gap-6 sm:grid-cols-2" }
const _hoisted_5 = { class: "h-48 w-full" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex flex-col space-y-1.5 p-6 pt-3" }
const _hoisted_8 = { class: "font-semibold tracking-tight text-2xl" }
const _hoisted_9 = { class: "text-sm opacity-50" }
const _hoisted_10 = { class: "p-6 pt-0 -my-1 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FolderOpenIcon = _resolveComponent("FolderOpenIcon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_FolderOpenIcon, { class: "inline-block h-9 w-9" }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deals, ({ title, date, description, imageSrc }, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "rounded-lg border bg-card text-card-foreground shadow-sm"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: imageSrc,
              class: "object-cover h-full w-full"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, _toDisplayString(title.replace('Closed: ', '')), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(date), 1)
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(description.replace(' [...]', '...')), 1)
        ]))
      }), 128))
    ])
  ]))
}